<template>
    <header>
        <div class="top bg_grey">
            <div class="d_f jc_sb P_s ai_c">
                <span>客服电话：023-68758478</span>
                <span>您好，欢迎来到重庆巨通交通安全设备制品有限公司</span>
            </div>
        </div>
        <div class="nav_wrap d_f ai_c jc_sb">
            <h1 class="d_f jc_sb c_black">
                <img src="../../assets/logo.png" alt="">
                <span class="P_xl">巨通交通</span>
            </h1>
            <nav class="h_1">
                <ul class="h_1 d_f">
                    <li class="h_1" v-for="(item,index) in nav" :key="index">
                        <router-link :to="item.path" class="d_b h_1 P_sl c_black">{{item.name}}</router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
</template>


<script>
import header from './header.js'
export default {
    ...header
}
</script>
<style lang="scss" scoped>

    header .top{
        height: 30px;
    }
    header .top>div{
        width: 1200px;
        margin: auto;
        height: 100%;
    }
    .nav_wrap{
        width: 1200px;
        margin: auto;
        height: 100px;
    }
    .nav_wrap h1{
        width: 233px;
        font-weight: 400;
    }
    .nav_wrap a{
        width: 145px;
        text-align: center;
        line-height: 100px;
    }
    .nav_wrap .router-link-active{
        position: relative;
        background-color: rgba(0,103,204,.1);
        color:#0067CC;
    }
    .nav_wrap .router-link-active::after{
        content: '';
        position: absolute;
        width: 40px;
        height: 12px;
        background-color:#0067CC ;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }

</style>